export { useApplePayAvailability } from './use-apple-pay-availability';
export { useGooglePayAvailability } from './use-google-pay-availability';
